import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { StorageUtils } from '../../../../utils/storage-utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Company } from '../../company/company';
import { TranslateService } from '@ngx-translate/core';
import { ProcessService } from '../../../process/process/process-service';
import { DocumentFile } from '../../document-file/document-file';
import { DocumentFileService } from '../../document-file/document-file-service';
import { FileUploader } from 'ng2-file-upload';
import { environment } from '../../../../../environments/environment';
import { FileUpload } from 'app/pages/ok-core/photo/file-upload';
import { v4 as uuidv4 } from 'uuid';

declare var require: any;
const deps: any = require('../../../../shared/data/document-dep-types.json');

@Component({
    selector: 'register-document-page',
    templateUrl: './register-document-page.component.html',
    styleUrls: ['./register-document-page.component.scss', '../../../../../assets/sass/libs/select.scss'],
    providers: [
        ProcessService,
        StorageUtils
    ],
    encapsulation: ViewEncapsulation.None
})
export class RegisterDocumentPageComponent implements OnInit {

    @Input()
    company: Company;

    doc: DocumentFile;

    upload: Boolean

    @ViewChild('vform') validationForm: FormGroup;
    form: FormGroup;

    @ViewChild('takeInput', { static: false })
    inputFile: ElementRef

    types = []

    listDeps = deps[this.storageUtils.getLoggedUser().type]

    selDep = {}

    uploader: FileUploader

    hasBaseDropZoneOver = false

    fileName: any

    currYear = new Date().getFullYear()
    lastYear = new Date().getFullYear() - 1

    competences = [
        '12/' + this.lastYear,
        '01/' + this.currYear,
        '02/' + this.currYear,
        '03/' + this.currYear,
        '04/' + this.currYear,
        '05/' + this.currYear,
        '06/' + this.currYear,
        '07/' + this.currYear,
        '08/' + this.currYear,
        '09/' + this.currYear,
        '10/' + this.currYear,
        '11/' + this.currYear,
        '12/' + this.currYear
    ]

    constructor(private router: Router,
        private route: ActivatedRoute,
        private docFileService: DocumentFileService,
        private storageUtils: StorageUtils,
        public activeModal: NgbActiveModal,
        private translate: TranslateService,
        private cdRef: ChangeDetectorRef) {

        this.doc = new DocumentFile()
        this.doc.fileBase = new FileUpload()
    }

    ngOnInit() {
        this.loadData()
        this.createUploader()
    }

    loadData() {
        this.form = new FormGroup({
            department: new FormControl(this.doc.department, [Validators.required, Validators.minLength(1)]),
            type: new FormControl(this.doc.type, [Validators.required, Validators.minLength(1)]),
            competence: new FormControl(this.doc.competence),
            date: new FormControl(this.doc.date, [Validators.required, Validators.minLength(1)]),
            expireDate: new FormControl(this.doc.expireDate, [Validators.required, Validators.minLength(1)])
        }, { updateOn: 'change' })
    }

    createUploader() {
        this.uploader = new FileUploader({
            url: `${environment.baseUrl}/documentFile/upload`,
            isHTML5: true,
            headers: [
                { name: 'Authorization', value: `Bearer ${this.storageUtils.getToken()}` },
                { name: 'Access-Control-Allow-Origin', value: '*' },
                { name: 'Access-Control-Allow-Headers', value: 'Content-Type' },
            ],
            itemAlias: 'file',
            queueLimit: 1,
            autoUpload: false,
            parametersBeforeFiles: true
        });
        this.uploader.onAfterAddingFile = (item: any) => {
            item.withCredentials = false;
            this.fileName = item.file.name


        };
        this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            this.inputFile.nativeElement.value = '';
            this.fileName = null
            this.createUploader()
            this.cdRef.detectChanges();
            this.activeModal.close(true)
        };
    }

    save() {
        this.validateAllFormFields(this.form)
        if (this.form.valid) {
            if (this.doc.id) {
                this.doc.department = this.doc.department?.['name'] ?? this.doc.department;

                this.uploader.options.additionalParameter = {
                    id: this.doc.id,
                    company_id: this.doc.companyId ?? null,
                    type: this.doc.type,
                    department: this.doc.department,
                    competence: this.doc.competence,
                    date: this.doc.date,
                    deadline: this.doc.deadline ?? null,
                    expire_date: this.doc.expireDate,
                    typeUser: this.storageUtils.getLoggedUser().type
                }
                this.uploader.uploadAll()

                this.docFileService.save(this.doc, result => {
                    this.activeModal.close(true)
                })
            } else {
                this.uploader.options.additionalParameter = {
                    company_id: this.company.id,
                    type: this.doc.type,
                    department: this.doc.department['name'],
                    competence: this.doc.competence,
                    date: this.doc.date,
                    deadline: this.doc.deadline ?? null,
                    expire_date: this.doc.expireDate,
                    typeUser: this.storageUtils.getLoggedUser().type
                }
                this.uploader.uploadAll()
            }
        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field)
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true })
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control)
            }
        });
    }
    filterDepUpdate(dep) {
        if (dep) {
            this.selDep = dep
            this.doc.type = null
        }
    }

    fileOverBase(e: any): void {
        this.hasBaseDropZoneOver = e;
    }

    fileChange(event, index) {
        if (!this.hasBaseDropZoneOver) {
            event.target.parentElement.querySelector('#uploadPDF').click()
        }
    }

    openAtt(row: any) {
        window.open(row.url)
    }

    removeAtt() {
        this.inputFile.nativeElement.value = '';
        this.fileName = null
        this.createUploader()
        this.cdRef.detectChanges();
    }
}
